module.exports = __webpack_public_path__ + "img/course-motiongraphics.1a7fa03.jpg";